import {
  FullscreenOverlayContainer,
  OverlayContainer,
} from "@angular/cdk/overlay";
import { DATE_PIPE_DEFAULT_OPTIONS } from "@angular/common";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { ApplicationConfig, isDevMode } from "@angular/core";
import {
  MAT_DATE_LOCALE,
  provideNativeDateAdapter,
} from "@angular/material/core";
import { MAT_DIALOG_DEFAULT_OPTIONS } from "@angular/material/dialog";
import { MAT_ICON_DEFAULT_OPTIONS } from "@angular/material/icon";
import { provideAnimations } from "@angular/platform-browser/animations";
import { provideRouter } from "@angular/router";
import { provideServiceWorker } from "@angular/service-worker";
import { tokenInterceptor } from "@kalmarenergi/data-access/iam/interceptors";
import { IdentityService } from "@kalmarenergi/data-access/iam/services/identity";
import {
  APP_ENVIRONMENT,
  MAT_DIALOG_DEFAULT_OPTIONS_VALUE,
} from "@kalmarenergi/util/config";
import { baseInterceptor } from "@kalmarenergi/util/interceptors";
import { environment } from "../environments/environment";
import { routes } from "./app.routes";

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    provideHttpClient(withInterceptors([baseInterceptor, tokenInterceptor])),
    provideRouter(routes),
    provideNativeDateAdapter(),
    { provide: APP_ENVIRONMENT, useValue: environment },
    {
      provide: MAT_ICON_DEFAULT_OPTIONS,
      useValue: { fontSet: "material-symbols-outlined" },
    },
    IdentityService,
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: MAT_DIALOG_DEFAULT_OPTIONS_VALUE,
    },
    { provide: MAT_DATE_LOCALE, useValue: "sv-SE" },
    {
      provide: DATE_PIPE_DEFAULT_OPTIONS,
      useValue: { dateFormat: "yyyy-MM-dd HH:mm:ss" },
    },
    provideServiceWorker("ngsw-worker.js", {
      enabled: !isDevMode(),
      registrationStrategy: "registerWhenStable:30000",
    }),
    {
      provide: OverlayContainer,
      useClass: FullscreenOverlayContainer,
    },
  ],
};
